function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .fb72113b-5277-4824-af9e-a4883da3ed43{fill:#fff;stroke-width:80px;}.a3a40b70-2bd7-4e44-9768-b9940c8f6171,.fb72113b-5277-4824-af9e-a4883da3ed43{stroke:#2a9d8f;stroke-linecap:round;stroke-linejoin:round;}.a3a40b70-2bd7-4e44-9768-b9940c8f6171{fill:none;stroke-width:40px;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "fa0f9e0b-bc57-4aab-90fd-ab11105c81a7",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "fb72113b-5277-4824-af9e-a4883da3ed43",
  d: "M1086,1410H364c-178.9,0-324-145.1-324-324V364C40,185.1,185.1,40,364,40h722c178.9,0,324,145.1,324,324v722C1410,1264.9,1264.9,1410,1086,1410Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "f70ad78a-02d0-442a-8b2a-3196e0a72543",
  "data-name": "fdb7d2c8-021b-416c-8458-c85ef9ff4880"
}, /*#__PURE__*/React.createElement("path", {
  className: "a3a40b70-2bd7-4e44-9768-b9940c8f6171",
  d: "M1031.6,850.4l96.5-369a72.07,72.07,0,0,0-47.1-90.1l-14.4-4.5a72.07,72.07,0,0,0-90.1,47.1L873.9,768.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "a3a40b70-2bd7-4e44-9768-b9940c8f6171",
  d: "M704.3,792.4l7.9-450.7a72,72,0,0,1,70.3-73.4l15.1-.4a72.06,72.06,0,0,1,73.5,70.3l2.9,430"
}), /*#__PURE__*/React.createElement("path", {
  className: "a3a40b70-2bd7-4e44-9768-b9940c8f6171",
  d: "M566.2,863,466.7,422.5a68.87,68.87,0,0,1,52.7-81.6l14.1-3a68.89,68.89,0,0,1,81.7,52.7l89.1,401.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "a3a40b70-2bd7-4e44-9768-b9940c8f6171",
  d: "M565.6,863,397.1,609.3a56.34,56.34,0,0,0-73.7-29.5l-10.9,4.7A56.22,56.22,0,0,0,283,658.1l131.5,284L467.4,1203l83.4,215.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "a3a40b70-2bd7-4e44-9768-b9940c8f6171",
  d: "M773.3,1282.9c-6.6-96.1,68.4-171.1,146.2-218.3a8.19,8.19,0,0,0,3.9-4.1c1.6-14,6.3-26.2,6.9-39.2-45.4-13.8-89.8-26.6-136.2-40.3-15.1-4.6-25.5-16.3-33.8-30.1-1-1-.1-3-1.1-4-9.4-14.7-9.9-31.7-8.3-47.8.6-16,3.1-32.1,16.8-43.5,10.8-7.3,22.7-9.6,34.8-9,79.2,5.8,155.2,6.8,235.7,22.6,19.1,4.5,32.5,17.1,42.9,32.8,11.5,18.7,17.1,39.5,19.7,60.5,10.8,64.7,5.5,128.9-10.8,191.4-19.5,54.6-38,109.1-57.6,163.6-10.3,26.3-20.6,51.6-28.9,78.8a20.52,20.52,0,0,0,.3,3.7"
}));

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e2880162-a659-49ce-bf9a-dcc43d3974d5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1450 1450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.49d1bb22.svg";
export { ForwardRef as ReactComponent };